exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.cloudSkill{opacity:.75;transition:.1s;cursor:default}span.cloudSkill:hover{opacity:1}", ""]);

// exports
